
import Layout from './Layout';
import '../../../../common/styles/app-legacy.scss'


export default {
    Layout
}